<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/user-management.vue'
import axios from 'axios'
import { hasErrors } from '@utils/form'
import { httpServices } from '@utils/http-services'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { features } from '@utils/features.const'

export default {
  page: {
    title: 'Organization Profile',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, VuePhoneNumberInput },
  data() {
    return {
      showOrganization: true,
      hasErrors,
      org: null,
      phone: null,
      features: features,
      formLayout: 'horizontal',
      form: this.$form.createForm(this, { name: 'coordinated' }),
    }
  },
  mounted() {
    httpServices.getOrganization(this.$route.params.orgId).then((res) => {
      this.org = res
      this.phone = this.org.meta.phone
      this.$nextTick(() => {
        // To disabled submit button at the beginning.
        this.form.validateFields()
      })
    })
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.org.meta = {
            ...this.org.meta,
            address: values.address,
            license: values.license,
            phone: this.phone,
          }
          this.org.permissions.features = values.features

          axios
            .put(process.env.VUE_APP_KONSUL_API_URL + '/orgs', this.org, {
              headers: {
                Authorization: 'Bearer ' + this.$auth.user.access_token,
              },
            })
            .then(
              (res) => {
                this.$notification.success({
                  message: `${
                    res?.data?.meta?.name || 'Org'
                  } Successfully Updated`,
                })
                this.$router.push({
                  name: 'user-management',
                })
              },
              () => {
                this.$notification.error({
                  message: 'Failed to Update Org',
                })
              }
            )
        }
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div v-if="showOrganization" class="ant-row profile--container">
      <div class="breadcrumb--container">
        <a-breadcrumb>
          <a-breadcrumb-item href="#">
            <router-link to="/">
              <a-icon type="home" />
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item href="#">
            <router-link to="/user-management">
              <a-icon type="team" />
              <span>User Management</span>
            </router-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>
            <a-icon type="profile" />
            Organization Profile
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="form-container">
        <div
          class="header"
          style="
            padding: 1.2rem;
            margin-bottom: 0;
            text-align: center;
            background: #141414;
            border-radius: 4px 4px 0 0;
          "
        >
          <h4 style="margin: 0; font-weight: 100; color: #fff">
            <a-icon type="profile" style="padding-right: 4px" />
            Organization Profile &middot; {{ this.$route.params.orgId }}
          </h4>
        </div>

        <template v-if="org">
          <a-card>
            <a-tabs default-active-key="1">
              <a-tab-pane key="1" tab="Organization Meta Data">
                <a-card style="width: 100%">
                  <a-form :form="form" @submit="handleSubmit">
                    <a-row>
                      <a-col :sm="16" :md="12">
                        <a-form-item label="Name">
                          <a-input
                            v-decorator="[
                              'name',
                              {
                                initialValue: org.meta.name,
                                rules: [
                                  {
                                    required: true,
                                    placeholder: 'Please input your name!',
                                  },
                                ],
                              },
                            ]"
                            :placeholder="this.$route.params.orgId"
                          />
                        </a-form-item>
                      </a-col>
                      <a-col :sm="16" :md="12">
                        <a-form-item label="Address">
                          <a-input
                            v-decorator="[
                              'address',
                              {
                                initialValue: org.meta.address,
                                rules: [
                                  {
                                    required: true,
                                    placeholder: 'Please input your address!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="License">
                          <a-input
                            v-decorator="[
                              'license',
                              {
                                initialValue: org.meta.license,
                                rules: [
                                  {
                                    required: true,
                                    placeholder: 'Please input your license!',
                                  },
                                ],
                              },
                            ]"
                          />
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <a-form-item label="Features">
                          <a-select
                            v-decorator="[
                              'features',
                              {
                                initialValue: org.permissions.features,
                              },
                            ]"
                            mode="multiple"
                          >
                            <a-select-option
                              v-for="(f, i) in features"
                              :key="i + f"
                              :value="f.id"
                            >
                              {{ f.name }}
                            </a-select-option>
                          </a-select>
                        </a-form-item>
                      </a-col>

                      <a-col :sm="16" :md="12">
                        <div class="ant-row ant-form-item">
                          <div class="ant-col ant-form-item-label">
                            <label class="ant-form-item-required">Phone</label>
                          </div>
                          <div class="ant-col ant-form-item-control-wrapper">
                            <VuePhoneNumberInput
                              v-model="phone"
                              :size="'sm'"
                              :required="true"
                            />
                          </div>
                        </div>
                      </a-col>
                    </a-row>

                    <a-row>
                      <a-form-item :wrapper-col="{ span: 12 }">
                        <a-button
                          type="primary"
                          html-type="submit"
                          :disabled="hasErrors(form.getFieldsError())"
                        >
                          Save
                        </a-button>
                      </a-form-item>
                    </a-row>
                  </a-form>
                </a-card>
              </a-tab-pane>
            </a-tabs>
          </a-card>
        </template>
        <template v-else>
          <div class="loader--container">
            <a-icon
              type="loading"
              style="padding-left: 4px; font-size: 24px; color: #1890ff"
              spin
            />
          </div>
        </template>
      </div>
    </div>
    <div v-else>
      <h1>403: Unauthorized</h1>
    </div>
  </Layout>
</template>
